import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

export const allFonts = [
    "sans-serif",
    "serif",
    "monospace",
    "arial",
    "times-new-roman",
    "courier-new",
    "georgia",
    "comic-sans-ms",
    "tahoma",
    "verdana",
    "calibri",
    "cambria",
    "garamond",
    "lucida-console",
    "palatino",
    "trebuchet-ms",
    "impact",
];


export const formats = [
    "font",
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "color",
    "background",
    "code-block",
    "list",
    "bullet",
    "script",
    "align",
    "link",
    "image",
    "video",
];


const Font = ReactQuill.Quill.import("formats/font");
Font.whitelist = allFonts;
ReactQuill.Quill.register(Font, true);


export const modules = {
    toolbar: [
        [{ font: Font.whitelist }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        ["link", "image", "video"],
        ["clean"],
    ],
};